import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { updateUserDetails, getshipNameList, getUserDetails, getUsersList } from "../Actions/UserManageAPI";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { getClientManagementDetails, getClientManagementList, putClientUserDetails } from "../Actions/ClientManagementAPI";

let searchData = {
    CompanyName: '',
    Mail: '',
    Phone: '',
    ClientType: '',
    PageNumber: 1,
    PageSize: 20
}
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class EditClientUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: {
                clientId: 0,
                companyName: "",
                mail: "",
                address: "",
                telephone: "",
                clientType: "",
                isDeleted: false,
                modifiedBy: currentUser.name,
            },
            ships: [],
            UserShips: [],
            index: 0
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.UpdateData = this.UpdateData.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onRemoveChange = this.onRemoveChange.bind(this);
    }

    componentDidMount() {
        const { match, dispatch } = this.props;
        const { params } = match;
        const { id } = params;
        dispatch(getClientManagementDetails(id));
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { ClientDetails, dispatch } = nextProps;
        if (ClientDetails && ClientDetails !== "") {
            prevState.userInfo.clientId = ClientDetails.clientId;
            prevState.userInfo.mail = ClientDetails.mail;
            // prevState.userInfo.isAdmin = UserDetails.isAdmin;
            // prevState.ships = UserDetails.mmplUserShips.map(r => { return (r.shipName) });
            // prevState.UserShips = UserDetails.mmplUserShips;
            dispatch({ type: "getClientDetailsSuccess", data: "" });
        }
    }

    handleInputChange(e) {
        this.state.userInfo.mail = e.target.value;
        this.setState({});
    }

    handleCheckBoxChange(e) {
        if (e.target.checked) {
            this.state.userInfo.isAdmin = true;
            this.setState({});
        } else {
            this.state.userInfo.isAdmin = false;
            this.setState({});
        }
    }

    UpdateData() {
        const { dispatch,t } = this.props;
        let url = `${API.getClientDetails}`;
        axios.put(url, this.state.userInfo, {
            headers: {
                key: currentUser.accessToken
            }
        })
            .then((response) => {

                dispatch(putClientUserDetails(this.state.userInfo));
                dispatch(getClientManagementList(searchData));
                this.props.history.goBack();
                dispatch({
                    type: "postClientDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postClientDetailsFailure",
                    error: "ERROR"
                })
            })
    }

    onSelectChange(item) {
        this.setState({ ships: item });
    }

    onRemoveChange(item) {
        this.setState({ ships: item });
    }

    hideSidePanel = () => {
        //  this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.goBack();
    };

    render() {
        const { shipNameList,t } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3">
                    <div className="col-lg-12">
                        <div className="panel-box search-filter-box">
                            {/* <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button> */}
                            <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                    {t("ClientManagementScreenContent.UpdateClientUser")}
                                    </h5>
                                </div>
                            </div>
                            <div className="search-filter-box">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <label className="form-label">{t("MMPLUserManagementContent.UserId")}</label>
                                        <br></br>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="mail"
                                            placeholder={t("MMPLUserManagementContent.UserId")}
                                            value={this.state.userInfo.mail}
                                            onChange={e => this.handleInputChange(e)}
                                        ></input>
                                    </div>
                                    {/* <div className="col-lg-2">
                                        <label className="form-label" >Is Admin</label><br></br>
                                        <input type="checkbox" name="isAdmin" checked={this.state.userInfo.isAdmin} onChange={(e) => this.handleCheckBoxChange(e)}></input>
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label" >Ship Name</label><br></br>
                                        <Multiselect options={shipNameList} isObject={false}
                                            style={{ option: { "marginRight": 0, "display": "block", "fontWeight": "normal" }, chips: { "background-color": "#1a3464" } }}
                                            onSelect={(item) => this.onSelectChange(item)}
                                            onRemove={(item) => this.onRemoveChange(item)}
                                            selectedValues={this.state.ships}
                                            placeholder={this.state.ships && this.state.ships.length != 0 ? "" : "Select"}
                                            closeIcon="cancel"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="row py-3">
                                <div className="col-lg-12">
                                    <div className="search-btn-col" style={{ textAlign: "end" }}>
                                        <button
                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                            type="submit"
                                            onClick={() => this.UpdateData()}
                                        >
                                            {" "}{t("EquipmentServiceTypes.Update")}{" "}
                                        </button>
                                        <button
                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                            type="button"
                                            onClick={() => this.hideSidePanel()}
                                        >
                                            {" "}{t("ComplianceandBudgetScreen.Cancel")}{" "}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        ClientDetails: state.MasterScreenReducer.ClientManagementDetails,
        shipNameList: state.UserManagerReducer.shipNameList,
        UsersList: state.UserManagerReducer.UsersList
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps)(EditClientUser));
